import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { LorenScrollService } from "../../../../shared/services/loren-scroll-service/loren-scroll.service";
import { GROUPS_ALL } from "../../../../shared/modules/loren-hierarchy-selector/constants/groups.constants";

@Component({
  selector: "loren-dashboard-widgets-modal",
  templateUrl: "./loren-dashboard-widgets-modal.component.html",
  styleUrls: ["./loren-dashboard-widgets-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LorenDashboardWidgetsModalComponent
  implements OnInit, AfterViewInit
{
  protected data = inject(MAT_DIALOG_DATA);
  private scrollService = inject(LorenScrollService);

  @ViewChild("dialog") dialog: ElementRef;

  assets: AssetWidget[];
  allSelected: boolean;

  ngOnInit(): void {
    this.assets = this.data
      .map((x) => {
        const result = {
          id: x.id,
          selected: x.show,
          imgGuid: x.image,
          title: x.name,
          ordinal: x.ordinal,
        };

        const groups = x.groups?.filter((y) => !GROUPS_ALL.includes(y));

        if (groups?.length > 0) {
          result.title += ` (${groups?.join(", ")})`;
        }

        return result;
      })
      .sort((a, b) => {
        if (a.selected && b.selected) {
          return a.ordinal - b.ordinal;
        } else {
          return a.selected ? -1 : 1;
        }
      });

    this.updateAllSelectedFlag();
  }

  ngAfterViewInit(): void {
    this.scrollService.setScrollableContent(this.dialog);
  }

  drop(event: CdkDragDrop<AssetWidget[]>) {
    moveItemInArray(this.assets, event.previousIndex, event.currentIndex);
  }

  save() {
    this.data.forEach((x) => {
      const assetIndex = this.assets.findIndex((a) => x.id === a.id);
      x.ordinal = assetIndex;
      x.show = this.assets[assetIndex].selected;
    });
    return this.data;
  }

  selectAll(value: boolean) {
    this.assets = this.assets.map((x) => {
      x.selected = value;
      return x;
    });

    this.allSelected = value;
  }

  selectionChanged() {
    this.reorder();
    this.updateAllSelectedFlag();
  }

  private updateAllSelectedFlag() {
    this.allSelected = this.assets.findIndex((x) => !x.selected) === -1;
  }

  private reorder() {
    this.assets = this.assets.sort((a, b) => {
      if (a.selected && b.selected) {
        return a.ordinal - b.ordinal;
      } else {
        return a.selected ? -1 : 1;
      }
    });

    this.scrollService.scrollToTop();
  }
}

export interface AssetWidget {
  id: number;
  title: string;
  imgGuid: string;
  selected?: boolean;
  ordinal?: number;
}
